module.exports = __webpack_public_path__ + "img/builtin_landscape_logo.2d229bca.png";